<template>
  <div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Device ID" prop="deviceId" min-width="224">
          <template v-slot="{ row }">
            <div>{{ row.deviceId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Device Type" prop="device" min-width="279"></el-table-column>
        <el-table-column label="Count" prop="count" min-width="222"></el-table-column>
        <el-table-column label="Percentage" prop="firstTime" min-width="223">
          <template v-slot="{ row }">
            <div>{{ row.rate }}%</div>
          </template>
        </el-table-column>
        <el-table-column label="Related Member" prop="users" min-width="223">
          <template v-slot="{ row }">
            <div class="users" @click="handleChange(row.deviceId)">{{ row.users }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <dia ref="dialogDom" class="label-dialog">
      <div>
        <el-table
          ref="table"
          :data="itemList"
          height="500"
          v-loading="loadingItem"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="User ID" prop="userId" min-width="15%">
            <template v-slot="{ row }">
              <div
                v-if="row.userId"
                @click="handleViewDetail(row)"
                style="text-decoration:underline;cursor: pointer;"
              >{{ row.userId }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Channel" prop="merchantName" min-width="17%"></el-table-column>
          <el-table-column label="Level" prop="userLevel" min-width="15%">
            <template v-slot="{ row }">
              <div v-if="row.userLevel">{{ formatUserLevel(row.userLevel) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Limit" prop="userLimit" min-width="17%">
            <template v-slot="{ row }">
              <div v-if="row.userLimitName">{{ row.userLimitName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Sports(30days)" min-width="25%" :show-overflow-tooltip="true">
            <template v-slot="{ row }">{{ getDataSport(row.betSports) }}</template>
          </el-table-column>
          <el-table-column label="Settled Stake(30days)" prop="stake" sortable min-width="18%">
            <template v-slot="{ row }">
              <div>{{ Number(row.stake) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="PL(30days)" prop="profit" sortable min-width="17%">
            <template v-slot="{ row }">
              <div>{{ Number(row.profit) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="PL%(30days)" prop="lastUseType" sortable min-width="17%">
            <template v-slot="{ row }">
              <div
                v-if="Number(row.profit) > 0"
              >{{ ((Number(row.profit) / Number(row.stake)) * 100).toFixed(2) }}%</div>
              <div v-else>0</div>
            </template>
          </el-table-column>
          <el-table-column label="Last Use Time" sortable prop="lastTime" min-width="20%">
            <template v-slot="{ row }">
              <div v-if="row.lastTime">{{ formatUtc(row.lastTime) }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="totalAert"
            :current-page="queryAlert.current"
            :page-size="queryAlert.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changeAlertPage"
            @size-change="handleSizeAlertChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
        <div class="dialog-footer table-search-part" style="padding-top: 20px;">
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import { getDeviceHistory, getDeviceItemInfo } from "@/api/memberDetail";
import { getRiskLevel, getLevelList } from "@/api/member";
import { getTcsSportList } from "@/api/memberDetail";
export default {
  name: "RiskDetail",
  components: {
    Empty,
    dia
  },
  props: {
    handleCheckHistoryStatus: {
      type: Boolean
    },
    handleCheckUserInfoStatus: {
      type: Boolean
    }
  },
  data() {
    return {
      list: [],
      itemList: [],
      total: 0,
      fastData: "",
      freeDate: "",
      rowIp: "",
      nowDate: Date.now(),
      form: {},
      firstActive: false,
      loading: false,
      loadingItem: false,
      queryData: {
        userId: "",
        current: 1,
        size: 50
      },
      totalAert: 0,
      queryAlert: {
        current: 1,
        size: 50
      },
      sportList: [],
      levelList: [],
      tableHeight: window.innerHeight,
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  watch: {
    handleCheckHistoryStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 150;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 150;
        });
      }
    },
    handleCheckUserInfoStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 115;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 115;
        });
      }
    }
  },
  methods: {
    async getSportList() {
      try {
        const res = await getTcsSportList({ matchType: '' });
        const data = res.data || {};
        this.sportList = data || [];
      } catch (error) {
        this.sportList = [];
      }
    },
    async getLevelList() {
      const res = await getLevelList({});
      let data = res.data || [];
      this.levelList = data;
    },
    async getList() {
      this.queryData.userId = this.$route.query.userId;
      this.loading = true;
      try {
        const res = await getDeviceHistory(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = Number(data.total);
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getItemList() {
      this.loadingItem = true;
      try {
        const res = await getDeviceItemInfo({
          deviceId: this.rowIp,
          current: this.queryAlert.current,
          size: this.queryAlert.size
        });
        const data = res.data.records || {};
        this.itemList = data || [];
        this.loadingItem = false;
        this.totalAert = Number(res.data.total);
      } catch (error) {
        this.itemList = [];
        this.loadingItem = false;
      }
    },
    // 获取运动字符串
    getDataSport(row) {
      let sportIds = row ? row : [];
      let str = "";
      this.sportList.map(item => {
        if (sportIds.includes(Number(item.code))) {
          str += item.value;
          str += "、";
        }
      });
      return str.slice(0, -1);
    },
    // 查看详情
    handleViewDetail(data) {
      if (data.userId) {
        this.Close();
        this.$router.push({
          path: "/member/detail",
          query: { userId: data.userId }
        });
      }
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    handleChange(data) {
      this.title = "Device ID Related Member";
      this.rowIp = data;
      this.$refs["dialogDom"].isShowDia(this.title, true, "1400px");
      this.getItemList();
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "1400px");
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // 分页
    changeAlertPage(e) {
      this.queryAlert.current = e;
      this.getItemList();
    },
    // 列表显示条目
    handleSizeAlertChange(e) {
      this.queryAlert.size = e;
      this.queryAlert.current = 1;
      this.getItemList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatDate(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD");
    },
    formatOddsLevel(val) {
      if (val == 1) {
        return "A";
      } else if (val == 2) {
        return "B";
      } else if (val == 3) {
        return "C";
      } else if (val == 4) {
        return "D";
      } else if (val == 5) {
        return "E";
      }
    },
    formatUserLevel(val) {
      let name = "";
      this.levelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    }
  },
  mounted() {
    this.firstActive = true;
    this.getSportList();
    this.getLevelList();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.el-dialog .el-table thead th {
  color: #fff !important;
  background: #2f4162 !important;
}
.bettinfo-date {
  font-size: 12px;
  margin: 0 0 15px 0;
}
.ip-name {
  color: #0184b8;
  font-weight: 700;
}
.re-ip-name {
  color: #e1554f;
}
.use-types {
  span {
    &:last-child {
      i {
        display: none;
      }
    }
  }
}
.users {
  color: #0184b8;
  cursor: pointer;
}
</style>
<style lang="scss">
.el-dialog .el-table thead th {
  color: #fff !important;
  background: #2f4162 !important;
}
</style>
